import { render } from "./ModalNotifications.vue?vue&type=template&id=dbac541c"
import script from "./ModalNotifications.vue?vue&type=script&lang=js"
export * from "./ModalNotifications.vue?vue&type=script&lang=js"

import "./ModalNotifications.vue?vue&type=style&index=0&id=dbac541c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__